import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
export const toHtml = (text) => (text || "").trim().split(/\n{2,}/).map((p) =>
  `<p>${esc(p).replace(/\*\*(.+?)\*\*/g, "<b>$1</b>").replace(/\n/g, "<br>")}</p>`).join("");
export const fromHtml = (html) => (html || "").replace(/<\/p>\s*<p>/g, "\n\n").replace(/<br\s*\/?>/g, "\n").replace(/<b>(.*?)<\/b>/g, "**$1**").replace(/<[^>]+>/g, "")
  .replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
export const fmtDay = (s) => (s ? new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");
export const fmtSize = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
export const token = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));
export const LIMITS_TEXT = "PDF, DOCX, XLSX, PPTX, CSV, TXT, JPG, PNG, WebP · up to 10 MB each · 5 files / 25 MB per upload";
export const REMINDER = "Share resources you have permission to share. Remove customer personal information before uploading.";
export const ALLOWED = ["pdf", "docx", "xlsx", "pptx", "csv", "txt", "jpg", "jpeg", "png", "webp"];

export async function openResource(r, mode = "download") {
  try {
    const { data } = await api.post(`/ideas/resources/${r.id}/link`, { mode });
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    window.open(`${base}${data.url}`, "_blank", "noopener");
  } catch (e) { toast.error(apiError(e)); }
}

export const SafeHtml = ({ html, className }) => <div className={`prose prose-sm max-w-none ${className || ""}`} dangerouslySetInnerHTML={{ __html: html }} />;
